import Teachers from "../components/Teachers";

export default function TeacherList() {
  return (
    <>
      <Teachers />
    </>
  );
}
